import React from 'react';
import { Modal, View, TouchableOpacity, StyleSheet } from 'react-native';
import Ionicons from '@expo/vector-icons/Ionicons';
import { Text } from './AppText';

// Modal de feedback estilizado (sucesso/erro/info) com o MESMO visual do modal
// "Conta criada" do UserAuthScreen — substitui os Alert.alert nativos, que
// destoavam do app. Card branco fixo (não segue tema) para bater com o original.
// Azul-base do cabeçalho do Perfil (#03386C, mesmo do COVER_GRADIENT) em vez do
// roxo global da marca: este modal só é usado pela ProfileScreen, então segue a
// cor daquela tela. Se um dia for reaproveitado em outra tela, receber a cor por
// prop em vez de recolorir aqui. O anel externo é o mesmo azul bem claro.
const BRAND = '#03386C';
const BRAND_SOFT = '#E6EFF9';

const VARIANTS = {
  success: { outer: BRAND_SOFT, inner: BRAND, icon: 'checkmark' },
  error: { outer: '#FEE2E2', inner: '#DC2626', icon: 'close' },
  info: { outer: BRAND_SOFT, inner: BRAND, icon: 'information' },
};

const FeedbackModal = ({
  visible,
  variant = 'info',
  title,
  message,
  buttonText = 'Entendi',
  onClose,
}) => {
  const v = VARIANTS[variant] || VARIANTS.info;

  return (
    <Modal
      visible={visible}
      transparent
      animationType="fade"
      statusBarTranslucent
      onRequestClose={onClose}
    >
      <View style={styles.overlay}>
        <View style={styles.card}>
          <View style={[styles.iconOuter, { backgroundColor: v.outer }]}>
            <View style={[styles.iconInner, { backgroundColor: v.inner }]}>
              <Ionicons name={v.icon} size={26} color="#FFFFFF" />
            </View>
          </View>

          {!!title && <Text style={styles.title}>{title}</Text>}
          {!!message && <Text style={styles.message}>{message}</Text>}

          <TouchableOpacity style={styles.button} onPress={onClose} activeOpacity={0.85}>
            <Text style={styles.buttonText}>{buttonText}</Text>
          </TouchableOpacity>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: 'rgba(17, 24, 39, 0.58)',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 26,
  },
  card: {
    width: '100%',
    maxWidth: 360,
    borderRadius: 24,
    backgroundColor: '#FFFFFF',
    paddingHorizontal: 22,
    paddingTop: 24,
    paddingBottom: 20,
    alignItems: 'center',
    shadowColor: '#000000',
    shadowOffset: { width: 0, height: 18 },
    shadowOpacity: 0.22,
    shadowRadius: 28,
    elevation: 16,
  },
  iconOuter: {
    width: 72,
    height: 72,
    borderRadius: 36,
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 16,
  },
  iconInner: {
    width: 48,
    height: 48,
    borderRadius: 24,
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    color: '#111827',
    fontSize: 23,
    lineHeight: 28,
    fontWeight: '900',
    textAlign: 'center',
  },
  message: {
    color: '#6B7280',
    fontSize: 14,
    lineHeight: 20,
    fontWeight: '600',
    textAlign: 'center',
    marginTop: 8,
  },
  button: {
    width: '100%',
    minHeight: 50,
    borderRadius: 14,
    backgroundColor: BRAND,
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 20,
    shadowColor: BRAND,
    shadowOffset: { width: 0, height: 8 },
    shadowOpacity: 0.22,
    shadowRadius: 14,
    elevation: 5,
  },
  buttonText: {
    color: '#FFFFFF',
    fontSize: 15,
    fontWeight: '900',
  },
});

export default FeedbackModal;
